export class PageTotal {
    page_total_standard: number;
    page_total_overtime: number;
    page_total_travel: number;
    page_total_mileage: number;
    page_total_expenses: number;
    page_count_po_part: number;
}